import { CONTACT_SECTION } from "@/content";

export const Contact = () => (
  <section className="contact" id="contato" data-testid="contact-section">
    <div className="wrap">
      <p className="eyebrow">{CONTACT_SECTION.eyebrow}</p>
      <h2>{CONTACT_SECTION.title}</h2>
      <p>{CONTACT_SECTION.text}</p>
      <div className="actions">
        <a
          className="btn gold"
          id="whatsapp"
          href={CONTACT_SECTION.whatsappCta.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-cta-whatsapp"
        >
          {CONTACT_SECTION.whatsappCta.label}
        </a>
        <a
          className="btn light"
          href={CONTACT_SECTION.instagramCta.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-cta-instagram"
        >
          {CONTACT_SECTION.instagramCta.label}
        </a>
      </div>
      <small>{CONTACT_SECTION.small}</small>
    </div>
  </section>
);
